export default {
  getPhotoFilename(photoByEmployeeId, item) {
    let employeePhoto = photoByEmployeeId[item.id];
    return employeePhoto ? employeePhoto.filename : null;
  },
  /**
   * The getItemBySearchText function returns true if a person with the search text within parts
   * of the name, position, department or tags is found.
   * @param item
   * @param search
   * @returns {accept}
   */
  isSearchTextIncludedInPersonAttributes({ item, search }) {
    let firstname = item.firstname ? item.firstname.toLowerCase() : '';
    let lastname = item.lastname ? item.lastname.toLowerCase() : '';
    let department = item.department ? item.department.toLowerCase() : '';
    let position = item.position ? item.position.toLowerCase() : '';
    let tags = item.tags ? item.tags.join(';') : '';

    const searchArray = (search ? search.toLowerCase() : '').split(' ');
    let accept = true;
    searchArray.forEach((searchItem) => {
      accept =
        firstname.includes(searchItem) ||
        lastname.includes(searchItem) ||
        department.includes(searchItem) ||
        position.includes(searchItem) ||
        tags.toLowerCase().includes(searchItem);
      if (!accept) return false;
    });
    return accept;
  },

  /**
   * The filteredPersonByDepartment function returns persons filtered by a department.
   * @param persons
   * @param departments
   * @returns {*}
   */
  filterPersonsByDepartment(persons, departments) {
    if (departments.length === 0) {
      return persons;
    } else {
      return persons.filter((item) => departments.includes(item.department));
    }
  },

  filterPersonsByPosition(persons, positions) {
    if (positions.length === 0) {
      return persons;
    } else {
      return persons.filter((item) => positions.includes(item.position));
    }
  },

  /**
   * The filterPersonsByTag function returns persons filtered by the chosen tag.
   * @param persons
   * @param tags
   * @returns {*}
   */
  filterPersonsByTag(persons, tags) {
    if (tags.length === 0) {
      return persons;
    } else {
      return persons.filter((item) => {
        let tag = item.tags ? item.tags.join(';') : '';
        return tag.includes(...tags);
      });
    }
  },

  /**
   * The filterPersonsByCompany function returns persons filtered by the chosen company.
   * @param persons
   * @param companies
   * @returns {*}
   */
  filterPersonsByCompany(persons, companies) {
    if (companies.length === 0) {
      return persons;
    } else {
      return persons.filter((item) => {
        return companies.includes(item.company);
      });
    }
  },
  /**
   * Orchestrieren mit der filterPersonByChips Funktion
   * @param persons
   * @param departments
   * @param positions
   * @param tag
   * @param companies
   * @returns {*}
   */
  filterPersonsByCatagories(persons, departments, positions, tag, companies) {
    let personFilteredByDepartment = this.filterPersonsByDepartment(persons, departments);
    let personFilterByPosition = this.filterPersonsByPosition(personFilteredByDepartment, positions);
    let personFilteredByTag = this.filterPersonsByTag(personFilterByPosition, tag);
    return this.filterPersonsByCompany(personFilteredByTag, companies);
  },

  getInitials(person) {
    if (person) {
      const { firstname, lastname } = person;

      return ((firstname ? firstname.charAt(0) : '') + (lastname ? lastname.charAt(0) : '')).toUpperCase();
    }
    // as a last resort use the id and if the employee is undefined (which should not be the case), use a exclamation mark
    return person ? person.id : '?';
  },
};
